// React and core libraries
import * as React from "react";
import { useEffect } from "react";

// Third-party libraries
import { FormControl } from "@mui/material";
import { StringParam, useQueryParam, withDefault } from "use-query-params";

// Internal utilities, hooks, and contexts
import { useDebounce } from "../../../utils/hooks";

// Relative imports (components from same directory)
import { ClusterFilterField } from "../ClustersFilterField";
import { TagFilter } from "../types";

type ClusterToolBarProps = {
  onNameFilterChange: (val?: string) => void;
  tagFilters?: TagFilter[];
  setTagFilters: (tagFilters: TagFilter[]) => void;
};

export const ClusterSearchBar = ({
  onNameFilterChange,
  tagFilters,
  setTagFilters,
}: ClusterToolBarProps): React.ReactElement => {
  const [clusterNameFilter, setClusterNameFilter] = useQueryParam(
    "clusterName",
    withDefault(StringParam, ""),
  );

  const debouncedClusterName = useDebounce(clusterNameFilter, 250);

  useEffect(() => {
    onNameFilterChange(debouncedClusterName);
  }, [debouncedClusterName, onNameFilterChange]);

  return (
    <FormControl sx={{ flex: 1 }}>
      <ClusterFilterField
        tagFilters={tagFilters}
        setTagFilters={setTagFilters}
        clusterNameFilter={clusterNameFilter}
        setClusterNameFilter={setClusterNameFilter}
      />
    </FormControl>
  );
};
